<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity, autoEnable: true }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Video from "@/models/video.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: Video.getSchema(),
			};
		},
		methods: {
			openEntity(entity) {
				this.$router.push(`/videos/${entity.id}`);
			},
			createEntity() {
				this.$router.push(`/videos/novo`);
			},
			searchEntities(paginationParameters) {
				return Video.search(paginationParameters);
			},
		},
	}
</script>